import React from 'react';
import './AboutUs.css';
import Header1 from '../components/Header1';
import Footer from '../components/Footer';

const AboutUs = () => {
    return (
        <>
            <Header1 />
            <div>
                {/* Mission Section - Full Width */}
                <section className="mission-section">
                    <h1>Our Mission</h1>
                    <p>We aim to build connections and strengthen networks.</p>
                </section>

                {/* Container for the rest of the sections */}
                <div className="container">

                    {/* Our Story Section */}
                    <section className="story-section">
                        <h2>Our Story</h2>
                        <p>
                            Upon discovering the concept of digital business cards, we realized that there were no companies delivering this service in the UK. 
                            So we decided to take action. Digicard aims to be a UK-based, global digital business card provider, allowing people to build connections with ease and strengthen networks.
                        </p>
                    </section>

                    {/* Founders Section */}
                    <section className="founders-section">
                        <h2>Digicard Founders</h2>
                        <div className="founder">
                            <h3>Cem Aslan</h3>
                            <p>
                                Cem Aslan is a Computer Science student at the University of Surrey who has a passion for solving problems and building digital products. 
                                His passion in computing first began at age 13 when he started learning about how computers worked and the components one consisted of. 
                                This later evolved into a passion in software and coding as he started developing his coding skills and building several sixth form projects.
                            </p>
                        </div>
                    </section>

                    {/* Investors Section */}
                    <section className="investors-section">
                        <h2>Investors</h2>
                    </section>

                </div>
            </div>
            <Footer />
        </>
    );
};

export default AboutUs;
